import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Container, Row, Col, Image, Form } from "react-bootstrap";
import { connect } from "react-redux";
import {
  updatePostStart,
  fetchSinglePostStart,
  postFileRemoveStart,
} from "../../../store/actions/PostAction";
import { createNotification } from "react-redux-notify/lib/modules/Notifications";
import { getErrorNotificationMessage } from "../../helper/NotificationMessage";
import { translate, t } from "react-multi-lang";
import "react-datetime/css/react-datetime.css";
import api from "../../../Environment";
import CreatePostLoader from "../../Loader/CreatePostLoader"

const EditPost = (props) => {
  const [inputData, setInputData] = useState({});
  const [image, setImage] = useState({ file: null, previewImage: "" });
  const [fileUploadStatus, setFileUploadStatus] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleChangeImage = (event, fileType) => {
    setProgress(0);
    if (event.currentTarget.type === "file") {
      setFileUploadStatus(true);
      let reader = new FileReader();
      let file = event.currentTarget.files[0];
      reader.onloadend = () => {
        setImage({ ...image, file: file, previewImage: reader.result });
      };

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  };

  const imageClose = (event) => {
    event.preventDefault();
    if (props.fileUpload.loadingButtonContent !== null) {
      const notificationMessage = getErrorNotificationMessage(
        "File is being uploaded.. Please wait"
      );
      props.dispatch(createNotification(notificationMessage));
    } else {
      props.dispatch(
        postFileRemoveStart({
          file: props.fileUpload.data.file,
          file_type: props.fileUpload.data.post_file.file_type,
          blur_file: props.fileUpload.data.post_file.blur_file,
          post_file_id: props.fileUpload.data.post_file.post_file_id,
        })
      );
      setImage({ previewImage: "", file: null });
      setFileUploadStatus(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (inputData.content == undefined) {
      const notificationMessage = getErrorNotificationMessage(
        "Content is required."
      );
      props.dispatch(createNotification(notificationMessage));
    }
    else {
      if (fileUploadStatus) {
        props.dispatch(
          updatePostStart({
            content: inputData.content ? inputData.content : "",
            preview_file: image.file ? image.file : "",
            post_id: props.singlePost.data.post.post_id
          })
        );
      }
      else {
        props.dispatch(
          updatePostStart({
            content: inputData.content ? inputData.content : "",
            post_id: props.singlePost.data.post.post_id
          })
        );
      }
    }
  };

  useEffect(() => {
    if (props.singlePost.loading)
      props.dispatch(
        fetchSinglePostStart({
          post_unique_id: props.match.params.post_unique_id,
        })
      );
  }, []);

  useEffect(() => {
    if (props.singlePost.data)
      if (props.singlePost.data.post) {
        setInputData({ content: props.singlePost.data.post.content })
        if (props.singlePost.data.post.postFiles.length > 0) {
          props.singlePost.data.post.postFiles.forEach(file => {
            setImage({
              previewImage: api.serviceUrl() +
                "/" + file.preview_file
            })
          });
        }
      }
  }, [props.singlePost.data]);

  return (
    <>
      {props.singlePost.loading ? (
        <CreatePostLoader></CreatePostLoader>
      ) : (
        <div className="notification-page create-post" id="tabs">
          <Container>

            <Form onSubmit={handleSubmit}>
              <Row>
                <Col sm={12} md={12}>
                  <div className="post-create-header">
                    <div className="pull-left">
                      <Link className="bookmarkes-list notify-title" to={"/home"}>
                        <Image
                          src="/assets/images/icons/back.svg"
                          className="svg-clone mr-2"
                        />
                        {t("edit_post")}
                      </Link>
                    </div>
                    <div className="pull-right">
                      <Button
                        type="submit"
                        className="post-btn btn-primary"
                        onClick={handleSubmit}
                        disabled={
                          props.updatePost.buttonDisable
                        }
                      >
                        {props.updatePost.loadingButtonContent !== null
                          ? props.updatePost.loadingButtonContent + " " + progress + "%"
                          : props.updatePost.loadingButtonContent !== null
                            ? props.updatePost.loadingButtonContent
                            : t("update")}
                      </Button>
                    </div>
                  </div>
                </Col>

                <Col sm={12} md={12}>
                  <div className="create-post-textarea">
                    <Form.Group>
                      <label className="form-label">{t("content")}</label>
                      <Form.Control
                        as="textarea"
                        className="border-bottom h-auto"
                        rows={3}
                        // placeholder={t("new_post_placeholder")}
                        name="content"
                        style={{ width: "100%", maxWidth: "100%" }}
                        value={inputData.content}
                        onChange={(event) =>
                          setInputData({
                            ...inputData,
                            content: event.currentTarget.value
                          })
                        }
                      />
                    </Form.Group>
                  </div>

                  {image.previewImage !== "" ? (
                    <Row>
                      <Col sm={12} md={1}>
                        <label className="form-label">{t("thumbnail")}</label>
                      </Col>
                      <Col sm={12} md={3}>
                        <div className="post-img-preview-sec">
                          {/* <Link to="#" onClick={imageClose}>
                            <i className="fa fa-times-circle"></i>
                          </Link> */}
                          <Image
                            alt="#"
                            src={image.previewImage}
                            className="post-video-preview"
                          />

                        </div>
                        {localStorage.getItem("is_document_verified") == 2 &&
                          (<>
                            <label htmlFor="fileupload_photo">
                              <Button className="post-btn" as="span">
                                {t("change_thumbnail")}
                              </Button>
                            </label>

                            <Form.Control
                              id="fileupload_photo"
                              type="file"
                              style={{ display: "none" }}
                              onChange={(event) => handleChangeImage(event, "image")}
                              name="preview_file"
                              accept=".gif,.jpg,.jpeg,.png"
                            />
                          </>)}
                      </Col>
                    </Row>
                  ) : null}
                </Col>
              </Row>
            </Form>
          </Container>
        </div>
      )}</>

  );
};

const mapStateToPros = (state) => ({
  singlePost: state.post.singlePost,
  updatePost: state.post.updatePost,
  fileUpload: state.post.fileUpload,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(translate(EditPost));
